import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { lazy } from 'react';
import { Retry } from '../retry';
/**
 * Lazy loading page component.
 *
 * @author Mikhail Siutsou
 * @function LazyPage
 * @category Hocs
 * @component
 * @param {string} folderName folder name.
 * @param {string} className class name.
 * @return {ExoticComponent} loaded component.
 */

var LazyPage = function LazyPage(folderName, className) {
  return /*#__PURE__*/lazy(function () {
    return Retry( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var exportedData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return import("@pages/".concat(folderName));

            case 2:
              exportedData = _context.sent;
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              exportedData["default"] = exportedData[className];
              return _context.abrupt("return", exportedData);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
  });
};

export { LazyPage };